<template>
  <v-dialog
    v-model="logoutDialog"
    fullscreen
    >
    <template
      v-slot:activator="{props}">
      <v-btn
        v-bind="props"
        rounded="lg"
        variant="tonal"
        color="#E88830"
        width="320px"
        class="mx-auto my-3"
        style="font-weight: bolder;">
        Logout
      </v-btn>
    </template>
    <template
      v-slot:default="{ isActive }">
      <v-card class="bg-grey-lighten-5">
        <v-container class="ma-auto">
          <v-row class="justify-center">
            <v-img :src="require(`@/assets/logout_badge.png`)"
            :max-width="257"
            :alt="`Emmie Badge`"
            class="ml-9"></v-img>
          </v-row>
          <v-spacer style="height: 40px;"></v-spacer>
          <v-row class="justify-center">
            <v-img :src="require(`@/assets/logout_pic.png`)"
            :alt="`Logout picture here`"
            :max-width="346"
            
            cover
            ></v-img>
          </v-row>
          <v-spacer style="height: 72px;"></v-spacer>
          <v-row class="justify-center">
            <span class="font-weight-black"
            style="font-size: 1.5rem; letter-spacing: 1.5px">App schließen?</span>
          </v-row>
          <v-spacer style="height: 60px;"></v-spacer>
          <v-row class="justify-center">
            <v-col cols="auto">
              <v-btn 
                type="submit" 
                v-on:click.prevent = "logoutLocal();"
                elevation="0"
                size="x-large"
                class="text-capitalize font-weight-black mx-auto"
                style=" font-size: 16px;"
                color="orange-lighten-4"
                >Ja</v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn @click="isActive.value = false;"
                elevation="0"
                size="x-large"
                class="text-capitalize font-weight-black mx-auto"
                style="font-size: 16px;"
                color="orange-lighten-4">
              Nein
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { AppStates } from "@/models/AppStates";

export default {
  data() {
    return {
      logoutDialog: false,
    }
  },
  methods:{
    logoutLocal(){
        AppStates.setIsServerAuthenticated(4,'');
        setTimeout(function(){
          location.href = '#/';
        }, 300);
      },
  }
}
</script>
